import {
  ACTION_ACCEPT,
  ACTION_APPROVE,
  ACTION_CANCEL,
  ACTION_CANCEL_ACCEPT,
  ACTION_CANCEL_APPROVE,
  ACTION_CANCEL_DECLINE,
  ACTION_CANCEL_OFFER,
  ACTION_CANCEL_REFUSE,
  ACTION_DECLINE,
  ACTION_REFUSE,
  ACTION_REINSTATE,
  ACTION_RETRACT
} from "./constants";

export function oneHourFromEarliestShift(event) {
  let oneHourFromEarliestShift = getEarliestShift(event);
  oneHourFromEarliestShift = oneHourFromEarliestShift.minus({ hours: 1 });
  return oneHourFromEarliestShift.toMillis();
}

export function getEarliestShift(event) {
  let offeredShiftStart = event.offeredShiftStart;
  let requestedShiftStart = null;
  if (event.requestedShiftStart) {
    requestedShiftStart = event.requestedShiftStart;
  }
  if (requestedShiftStart) {
    if (offeredShiftStart.toMillis() < requestedShiftStart.toMillis()) {
      return offeredShiftStart;
    } else {
      return requestedShiftStart;
    }
  } else {
    return offeredShiftStart;
  }
}

export function isTwoMonthSubmissionDeadlineRequired(action) {
  return action === ACTION_CANCEL || action === ACTION_REINSTATE;
}

export function isHourSubmissionDeadlineRequired(action) {
  return action === ACTION_CANCEL_OFFER;
}

export function isExpiredEmployeeEventCheckRequired(action) {
  // Expired-EE needs to be checked on retracted, declined, accepted
  // Cancel Expired-EE needs to be checked on cancel accept, cancel declined
  return (
    action === ACTION_RETRACT ||
    action === ACTION_DECLINE ||
    action === ACTION_ACCEPT ||
    action === ACTION_CANCEL_ACCEPT ||
    action === ACTION_CANCEL_DECLINE
  );
}

export function isExpiredAdminEventCheckRequired(action) {
  // Expired-ADM needs to be checked on admin approved, admin refused
  // Cancel Expired-ADM needs to be checked on admin cancel approve, admin cancel refuse
  return (
    action === ACTION_APPROVE ||
    action === ACTION_REFUSE ||
    action === ACTION_CANCEL_APPROVE ||
    action === ACTION_CANCEL_REFUSE
  );
}
